import { motion } from "framer-motion";
import { ALLIES, ALLIES_CONTENT } from "../data/allies";

export const Allies = ({ lang }) => (
  <section id="allies" data-testid="allies-section" className="scroll-mt-24 border-t border-white/10 px-5 py-24 sm:px-8 sm:py-32">
    <div className="mx-auto max-w-7xl">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-14 max-w-2xl"
      >
        <span className="text-xs font-semibold uppercase tracking-[0.28em] text-amber-400">{ALLIES_CONTENT.eyebrow[lang]}</span>
        <h2 className="font-display mt-4 text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">{ALLIES_CONTENT.title[lang]}</h2>
        <p className="mt-4 text-base text-slate-400 sm:text-lg">{ALLIES_CONTENT.sub[lang]}</p>
      </motion.div>

      <div className="grid gap-4 md:grid-cols-3">
        {ALLIES.map((a, i) => (
          <motion.div
            key={a.id}
            data-testid={`ally-card-${a.id}`}
            initial={{ opacity: 0, y: 36 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.65, delay: i * 0.1 }}
            whileHover={{ y: -6 }}
            className="group relative overflow-hidden rounded-2xl border border-white/10 bg-[#121722] p-8 transition-colors duration-500 hover:border-amber-400/40"
          >
            <div className="absolute -right-6 -top-6 h-24 w-24 rounded-full bg-amber-400/10 blur-2xl transition-opacity duration-500 group-hover:opacity-100" />
            <div className="font-display flex h-14 w-14 items-center justify-center rounded-xl border border-amber-400/25 bg-amber-400/10 text-2xl font-bold text-amber-400">
              {a.name.charAt(0)}
            </div>
            <h3 className="font-display mt-6 text-2xl font-semibold text-white">{a.name}</h3>
            <p className="mt-2 text-xs font-semibold uppercase tracking-[0.22em] text-slate-400">{a.role[lang]}</p>
            <div className="mt-6 h-px w-full bg-gradient-to-r from-amber-400/50 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
